document.addEventListener('DOMContentLoaded', () => {
  console.log('[dual-bgn] loaded');

  const EUR_TO_BGN = 1.95583;
  const INLINE_CLASS = 'dual-bgn-inline';

  function parseMoney(text) {
    if (!text) return NaN;
    let s = String(text).trim();

    // ако е dual: "€12,34 / 24,13 лв" -> взимаме първата част
    if (s.includes('/')) s = s.split('/')[0].trim();

    // махаме валути/букви, оставяме цифри и разделители
    s = s.replace(/[^\d.,\s-]/g, '').replace(/\s+/g, '');

    const lastDot = s.lastIndexOf('.');
    const lastComma = s.lastIndexOf(',');

    // BG/ES: 1.234,56
    if (lastComma > lastDot) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else {
      // EN: 1,234.56
      s = s.replace(/,/g, '');
    }

    const n = parseFloat(s);
    return Number.isFinite(n) ? n : NaN;
  }

  function formatBGN(x) {
    try {
      return (
        new Intl.NumberFormat('bg-BG', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(x) + ' лв'
      );
    } catch (e) {
      return x.toFixed(2) + ' лв';
    }
  }

  function setInlineBGN(el, eurValue) {
    const bgnValue = eurValue * EUR_TO_BGN;

    // правим/ъпдейтваме само нашия inline span
    let inline = el.querySelector(`:scope > .${INLINE_CLASS}`);
    if (!inline) {
      inline = document.createElement('span');
      inline.className = INLINE_CLASS;
      el.appendChild(inline);
    }
    inline.textContent = ' / ' + formatBGN(bgnValue);
  }

  function getBaseText(el) {
    // взимаме текста на елемента, но без нашия inline
    const clone = el.cloneNode(true);
    clone.querySelectorAll(`.${INLINE_CLASS}`).forEach(n => n.remove());
    return (clone.textContent || '').trim();
  }

  function isLeafPriceNode(el) {
    if (!el || !el.tagName) return false;

    // ако има много деца (извън нашия inline), не го пипаме
    const children = Array.from(el.children || []).filter(
      c => !c.classList.contains(INLINE_CLASS)
    );
    if (children.length > 0) return false;

    return true;
  }

  function shouldSkip(el) {
    if (!el) return true;

    // не пипаме нашия inline span
    if (el.classList && el.classList.contains(INLINE_CLASS)) return true;
    if (el.closest && el.closest(`.${INLINE_CLASS}`)) return true;

    if (!isLeafPriceNode(el)) return true;

    const base = getBaseText(el);
    if (!base) return true;

    // Конвертираме САМО ако базовият текст има €
    // (така няма да добавим BGN върху BGN или върху някакви други текстове/контейнери)
    if (!base.includes('€')) return true;

    // ако базовият текст вече съдържа лв (т.е. темата е сложила лев вътре) – не добавяме втори
    if (base.includes('лв')) return true;

    return false;
  }

  function convertEl(el) {
    if (shouldSkip(el)) return;

    const base = getBaseText(el);

    const eur = parseMoney(base);
    if (!Number.isFinite(eur)) return;

    setInlineBGN(el, eur);
  }

  // ====== СЕЛЕКТОРИ (leaf only, без контейнери) ======
  const selectors = [
    /* ===== HOME / COLLECTIONS / CAROUSELS / RELATED ===== */
    '.wrap_sawp_price ins',
    '.wrap_sawp_price del',
    '.wrap_sawp_price .current_price',
    '.wrap_sawp_price .price_varies.current_price',
    '.wrap_sawp_price [data-hulkapps-ci-price]',

    /* ===== PRODUCT PAGE ===== */
    'span.price_varies.current_price',
    '.product-price .current_price',
    '.product-price .price_varies',
    '.product-price ins',
    '.product-price del',
    '.price_range .current_price',
    '.price_range ins',
    '.price_range del',
    '.product__price ins',
    '.product__price del',

    /* ===== STICKY ADD TO CART (leaf only) ===== */
    '.sticky_atc_price .current_price',
    '.sticky_atc_price ins',
    '.sticky_atc_price del',

    /* ===== CART DRAWER (items) ===== */
    '.mini_cart_item .cart_price',
    '.mini_cart_item .cart_meta_price',
    '.mini_cart_item .current_price',
    '.mini_cart_item ins',
    '.mini_cart_item del',
    '.mini_cart_item [data-hulkapps-ci-price]',

    /* ===== CART DRAWER (totals) ===== */
    '.mini_cart_footer .money',
    '.mini_cart_footer .cart_tot_price',
    '.js_cat_ttprice .money',
    '.js_cat_ttprice',

    /* ===== CART PAGE (items) ===== */
    '.cart-item-price',
    'span.cart-item-price',
    '.cart_price span[data-hulkapps-ci-price]',
    '.cart_price ins',
    '.cart_price del',

    /* ===== CART PAGE (totals) ===== */
    '[data-hulkapps-cart-total]',
    '.cart_tot_price',
    'div.cart_tot_price',
    /* ===== HOVER CAROUSELS / PRODUCT CARDS ===== */
'.product .price',
'.product .price ins',
'.product .price del',
'.product .price .current_price',
'.product .price .price_varies',
'.product-inner .price',
'.product-inner .price ins',
'.product-inner .price del',
'.product-inner .current_price',
'.product-inner .price_varies',
'.product-card .price ins',
'.product-card .price del',
'.product-card .current_price',
/* ===== RELATED / RECENTLY VIEWED (more specific) ===== */
'#recently_wrap .wrap_sawp_price .money',
'#recently_wrap .wrap_sawp_price .amount',
'#recently_wrap .wrap_sawp_price .current_price',
'#recently_wrap .wrap_sawp_price .price_varies',
'#recently_wrap .wrap_sawp_price ins',
'#recently_wrap .wrap_sawp_price del',

'[data-section-type="product-recently"] .wrap_sawp_price .money',
'[data-section-type="product-recently"] .wrap_sawp_price .amount',
'[data-section-type="product-recently"] .wrap_sawp_price .current_price',
'[data-section-type="product-recently"] .wrap_sawp_price .price_varies',
'[data-section-type="product-recently"] .wrap_sawp_price ins',
'[data-section-type="product-recently"] .wrap_sawp_price del',
  /* ================= RELATED / RECENTLY VIEWED (cards) ================= */
  '.wrap_sawp_price',                 // <-- ВАЖНО: цената е plain text тук
  '#recently_wrap .wrap_sawp_price',  // (по желание, по-конкретно)
  '.product-info .wrap_sawp_price',   // (по желание, по-конкретно)



  ];

  function run() {
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(convertEl);
    });
  }

  // първо минаване
  run();

  // variant/change hooks
  document.querySelectorAll('[name="id"], .product-form__input input[type="radio"]').forEach(el => {
    el.addEventListener('change', () => setTimeout(run, 180));
  });

  // AJAX / drawer updates
  const obs = new MutationObserver(() => {
    clearTimeout(window.__dualBGNTimer);
    window.__dualBGNTimer = setTimeout(run, 120);
  });
  obs.observe(document.body, { childList: true, subtree: true, characterData: true });

  // theme/app cart events
  ['ajaxCart.afterCartLoad','cart.requestComplete','cart:updated','cart:change','cart:build','cart:refresh'].forEach(ev => {
    document.addEventListener(ev, () => setTimeout(run, 150));
  });
});
